import { CSSObject } from '@chakra-ui/react';

export const StyledDatePicker: CSSObject = {
  '&&&': {
    '.chakra-input, .react-date-picker__wrapper': {
      h: '38px',
      background: 'blackAlpha.500',
      color: 'white',
      borderRadius: 'base',
      transition: 'all .2s ease-in-out',
      fontSize: 'xs',
      px: '2',
      'input, span': {
        fontFamily: 'accent',
        fontWeight: 'normal',
      },
      button: {
        color: 'alpha.300',
      },
      boxShadow: 'none',
      _hover: {
        opacity: 0.9,
      },
    },
  },
};
